"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LanguageSwitcherFeature = require("./LanguageSwitcherFeature");
Object.keys(_LanguageSwitcherFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageSwitcherFeature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageSwitcherFeature[key];
    }
  });
});
